import { useEffect } from 'react'

import { ModalType } from '$/types'
import { useAppDispatch } from 'app/hooks'
import { useLazyGetContinuousRoutesFilterProfileQuery } from 'app/services/api/filterprofiles'

import FilterModal from '.'
import { setFilteredNetworkListSync } from '../globalFilterSlice'

type QueryBody = {
  operatorCodes: Array<string>
  stateCodes: Array<string>
  regionCodes: Array<string>
  customQuery: string
  customQueryString: string
}

const body: QueryBody = {
  operatorCodes: [],
  stateCodes: [],
  regionCodes: [],
  customQuery: '',
  customQueryString: ''
}

const SystemScopeModalWrapper = ({ onClose }: ModalType) => {
  const dispatch = useAppDispatch()

  const [getProfileContinuousRoutes, { isLoading }] =
    useLazyGetContinuousRoutesFilterProfileQuery()

  /**
   * Initialize network line list
   */
  useEffect(() => {
    getProfileContinuousRoutes(body)
      .unwrap()
      .then((res) => {
        dispatch(setFilteredNetworkListSync(res))
      })
  }, [dispatch, getProfileContinuousRoutes])

  return <FilterModal onClose={onClose} isIncludingRoutes={isLoading} />
}

export default SystemScopeModalWrapper
